import { render } from "./SimpleEditor.vue?vue&type=template&id=60daf256&ts=true"
import script from "./SimpleEditor.vue?vue&type=script&lang=ts"
export * from "./SimpleEditor.vue?vue&type=script&lang=ts"

import exportComponent from "/root/.jenkins/workspace/test-saas-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__